<template>
    <div id="notifications-template">
        <v-breadcrumbs
            :items="[
                { text: 'Dashboard', to: { path: '/' } },
                { text: 'Tryout', to: { path: '/tryouts' } },
                { text: 'Rating dan Feedback Tryout' },
            ]"
            divider="|"
        ></v-breadcrumbs>

        <div>
            <v-row>
                <v-col cols="12" md="10">
                    <h3 class="header-text font-weight-bold">
                        Rating dan Feedback Tryout
                    </h3>
                </v-col>
            </v-row>
        </div>

        <v-card>
            <v-card-title> Rating dan Feedback Tryout </v-card-title>
            <v-divider />

            <app-datatable
                :items="data"
                :headers="headers"
                :has-action="false"
                :has-export="true"
                :has-duplicate="true"
                :has-custom-pagination="true"
                :has-custom-search="true"
                :custom-pagination-current-page="pagination.currentPage"
                :custom-pagination-per-page="pagination.perPage"
                :custom-pagination-total-pages="pagination.totalPages"
                :custom-pagination-sort-mode="pagination.sortMode"
                v-on:selected="selectedRow = $event"
                v-on:exportClicked="exportTryout()"
                v-on:changePage="
                    pagination = { ...pagination, currentPage: $event }
                "
                v-on:changeSortMode="
                    pagination = { ...pagination, sortMode: $event }
                "
                v-on:doSearch="
                    search = {
                        query: $event.value,
                        by: headersKey[$event.key],
                    };
                    doSearch();
                "
            ></app-datatable>
        </v-card>

        <app-spinner v-if="isLoading"></app-spinner>
    </div>
</template>

<script>
import _ from "lodash";
import AppSpinner from "@/modules/global/components/plugins/Spinner";
import DataTable from "@/modules/global/components/plugins/DataTable-c";
import axios from "axios";
import moment from "moment";

export default {
    name: "notifications-template",

    components: {
        "app-datatable": DataTable,
        "app-spinner": AppSpinner,
    },

    data: function () {
        return {
            isLoading: false,
            selectedRow: "",
            total: 0,
            start_date: "",
            end_date: "",
            search: "",
            tableKey: "",
            sortBy: "",
            filters: "",
            pagination: {
                perPage: 10,
                currentPage: 1,
                totalPages: 0,
                sortMode: "desc",
            },
            params: {
                page: 1,
                perPage: 10,
                sortMode: "desc",
                tryout_name: "",
                tryout_date: "",
                rating: "",
                feedback: "",
            },
            data: [],
            headers: [
                { text: "Nama Tryout", value: "tryout_name", width: "200px" },
                { text: "Tanggal", value: "tryout_date" },
                { text: "Rating", value: "rating" },
                { text: "Feedback", value: "feedback", width: "300px" },
            ],
            filter_type: "ALL",
            menu: false,
            modal_date: false,
            modal_date2: false,
            date: "",
            date2: "",
        };
    },

    watch: {
        pagination() {
            this.fetchListRating();
        },
    },

    mounted: function () {
        this.fetchListRating();
    },

    methods: {
        fetchListRating() {
            const context = this;
            const param = `?page=${context.pagination.currentPage}&per_page=${context.pagination.perPage}`;
            const url = `${process.env.API_BASE_URL}tryout-service/admin/rating${param}`;

            const authToken = JSON.parse(localStorage.getItem("token")).value;

            const options = {
                headers: {
                    Authorization: "Bearer " + authToken,
                },
            };

            axios.get(url, options).then(function (response) {
                if (response.status === 200) {
                    // context.data = response.data.ratings;
                    response.data.ratings.forEach(function (item) {
                        context.data.push(item);
                        item.tryout_date = moment(item.tryout_date).format(
                            "DD MMM YYYY",
                        );
                    });

                    context.pagination.totalPages = response.data.max_page;
                }
            });
        },
        doSearch() {
            this.params.page = 1;
            this.pagination.currentPage = 1;

            if (!this.search.by || !this.search.query) {
                this.clearFilter();
            } else {
                this.params[this.search.by] = this.search.query;
            }

            if (this.search.by === "tryout_name") {
                this.params.tryout_name = this.search.query;
            } else if (this.search.by === "rating") {
                this.params.rating = this.search.query;
            } else if (this.search.by === "problem") {
                this.params.problem = this.search.query;
            } else if (this.search.by === "feedback") {
                this.params.feedback = this.search.query;
            } else if (this.search.by === "tryout_date") {
                this.params.tryout_date = Moment(this.search.query).format(
                    "YYYY-MM-DD",
                );
            }

            this.fetchListRating();
        },
        clearFilter() {
            this.params = {
                page: 1,
                perPage: 10,
                sortMode: "desc",
                tryout_name: "",
                tryout_date: "",
                rating: "",
                feedback: "",
            };
        },
    },
};
</script>



// WEBPACK FOOTER //
// TryoutRating.vue?45082224